export const environment = {
	production: false,
	preproduction: false,
	staging: false,
	sandbox: false,
	analytics: false,
	apiUrl: '/operator-api/api/{language}/operator',
	socketHost: 'http://localhost:6001',
	socketChannel: 'yeti_database_yeti_local'
};
